import * as React from "react";
import { forwardRef } from "react";
const SvgTelemetry = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	fill: "currentColor",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M1.5 1.8c0-.2-.1-.4-.2-.5S.9 1 .8 1s-.4.1-.6.2c-.1.2-.2.4-.2.6v12.5c0 .4.3.7.8.7h14.5c.2 0 .4-.1.5-.2.1-.1.2-.3.2-.5s-.1-.4-.2-.5c-.1-.1-.3-.2-.5-.2H1.5V1.8zm14.3 2.5c.1-.2.2-.4.2-.5 0-.2-.1-.4-.2-.5-.2-.2-.4-.3-.6-.3-.2 0-.4.1-.5.2L10 7.9 7.5 5.5c-.1-.2-.3-.2-.5-.2s-.4 0-.5.2L3.2 8.7c-.1.2-.2.4-.2.5 0 .2.1.4.2.5.2.2.4.3.6.3.2 0 .4-.1.5-.2L7 7.1l2.5 2.5c.1.1.3.1.5.1s.4-.1.5-.2l5.3-5.2z" }));
const ForwardRef = forwardRef(SvgTelemetry);
export default ForwardRef;
